module.exports = __webpack_public_path__ + "static/img_4346-8a21a061d80eb0f598d8d070dda33bd8.webp";